export const EVENT_JOB_START = 'job_start';
export const EVENT_JOB_FAIL = 'job_fail';
export const EVENT_JOB_REMOVE = 'job_remove';
